import mapiConfig from "../configs/mapi";
import { httpMStepsClient } from "./utils/httpService";
import sapiConfig from "../configs/sapi";

//BASE_URL
const MAPI_BASE_URL = mapiConfig.api.domain;
const SAPI_BASE_URL = sapiConfig.api.domain;
const Controller = "/customer";

export const getPortalSalesOrder = async (queryParams: any) => {
  const methodPath = `${Controller}/portal-orders?${queryParams.toString()}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};
